import { lazy, Suspense } from 'react';
import AuthenticatedShellReloadPreview from '#kernel/app-shell/AuthenticatedShellReloadPreview.tsx';
import type {
  AuthenticatedReloadPreviewContribution,
  AuthenticatedReloadPreviewRequest,
} from '#kernel/plugin-system/authenticated-reload-preview-types.ts';
import { matterLexiAuthenticatedReloadPreviewDestination } from './runs-in-browser/reload-preview/matter-lexi-authenticated-reload-preview-destination.ts';
import { MATTER_LEXI_AUTHENTICATED_RELOAD_PREVIEW_ID } from './runs-in-browser/reload-preview/matter-lexi-authenticated-reload-preview-id.ts';

const loadMatterLexiAuthenticatedReloadPreview = () =>
  import('./runs-in-browser/reload-preview/MatterLexiAuthenticatedReloadPreview.tsx');
const MatterLexiAuthenticatedReloadPreview = lazy(loadMatterLexiAuthenticatedReloadPreview);

function MatterLexiReloadPreviewPending({
  request,
}: {
  request: AuthenticatedReloadPreviewRequest;
}) {
  return (
    <AuthenticatedShellReloadPreview
      primaryNavigationHidden={request.primaryNavigationHidden}
      userId={request.userId}
    >
      <div
        aria-busy="true"
        aria-label="Restoring Lexi workspace"
        className="application-loading-placeholder__card"
        role="status"
      />
    </AuthenticatedShellReloadPreview>
  );
}

export default {
  id: MATTER_LEXI_AUTHENTICATED_RELOAD_PREVIEW_ID,
  render: (request) => {
    if (!matterLexiAuthenticatedReloadPreviewDestination(request.destination)) return null;
    return (
      <Suspense fallback={<MatterLexiReloadPreviewPending request={request} />}>
        <MatterLexiAuthenticatedReloadPreview request={request} />
      </Suspense>
    );
  },
} satisfies AuthenticatedReloadPreviewContribution;
